import { render, staticRenderFns } from "./LeftNavi.vue?vue&type=template&id=25363c9a&scoped=true&"
import script from "./LeftNavi.vue?vue&type=script&lang=js&"
export * from "./LeftNavi.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavi.vue?vue&type=style&index=0&id=25363c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25363c9a",
  null
  
)

export default component.exports